import { FC } from 'react';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

type Props = {
  change: number;
};

const ChangeIcon: FC<Props> = ({ change }) => {
  if (change === 0) return null;

  if (change > 0)
    return (
      <ArrowDropUpIcon
        sx={{
          verticalAlign: 'middle',
          display: 'inline-block',
          color: 'error.main',
        }}
      />
    );

  return (
    <ArrowDropDownIcon
      sx={{
        verticalAlign: 'middle',
        display: 'inline-block',
        color: 'success.main',
      }}
    />
  );
};

export default ChangeIcon;
